import {API_ENDPOINT, API_CLIENT_ID, API_CLIENT_SECRET} from 'config/config';
import Grant from 'util/api/Grant';
import Api from 'util/api/Api';

export const
    REQUEST_TOKEN_SUCCESS = 'REQUEST_TOKEN_SUCCESS',
    REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS',
    DESTROY_TOKEN_SUCCESS = 'DESTROY_TOKEN_SUCCESS';

export const getInitialState = () => new Grant();

export const apiReducer = (state = getInitialState(), action = {}) => {
    switch (action.type) {
    case REFRESH_TOKEN_SUCCESS:
    case REQUEST_TOKEN_SUCCESS:
    case DESTROY_TOKEN_SUCCESS:
        return new Grant(action.grant);
    default:
        return state;
    }
};

let _api = null;

export const getApi = () => {
    if (!_api) {
        _api = new Api(API_ENDPOINT, API_CLIENT_ID, API_CLIENT_SECRET);
    }

    return _api;
};

export const setURLParams = (url, urlParams) => {
    const urlKeys = Object.keys(urlParams);
    let _url = url;

    urlKeys.forEach(key => {
        _url = url.replace(`:${key}`, urlParams[key]);
    });

    return _url;
};


export const clearCache = () => dispatch =>
    Object.keys(require('modules/store').default())
        .forEach(key =>
            dispatch(require(`modules/store/${key}`)[Object.keys(require(`modules/store/${key}`)).find(item => item.includes('invalidate'))]()));



// WEBPACK FOOTER //
// ./src/modules/api.js